import React, { useCallback, useEffect, useReducer, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Table, Button } from "react-bootstrap";
import ModalCuentaAdmin from "./modaladmin/ModalCuentaAdmin";
import ModalChangePassword from "./modaladmin/ModalChangePassword";
import Swal from "sweetalert2";
import {
  insertAdmin,
  updateAdmin,
  getAllAdmin,
  UpdateEstadoAdmin,
  changePasswordAdmin,
  getAdminCredentials,
} from "../../../Api/AdminApi";

const showReducer = (curShow, state) => {
  switch (state.type) {
    case "SHOW":
      return {
        isShow: true,
        typeModal: state.typeModal,
        onReturnValue: state.onReturnValue,
        item: state.item || null,
      };
    case "END":
      return { ...curShow, isShow: false };
    default:
      return curShow;
  }
};

export const Admin = () => {
  const [Feriados, setFeriados] = useState([]);
  const [userdata, setUSERDATA] = useState();
  const [isnewFeriado, setIsnewFeriado] = useState(true);
  const [datoFeriado, setDatoFeriado] = useState([]);

  useEffect(() => {
    assigmentValueAdmin();
  }, []);

  const assigmentValueAdmin = useCallback(async () => {
    try {
      const [adminResult, userData] = await Promise.all([
        getAllAdmin(),
        getAdminCredentials(),
      ]);
      setUSERDATA(userData);
      setFeriados([...adminResult]);
    } catch (err) {
      console.log(err);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "No se pudo cargar los datos.",
        confirmButtonColor: "#00273a",
      });
    }
  }, []);

  const [reducer, dispatchReducer] = useReducer(showReducer, {
    isShow: false,
    typeModal: null,
    onReturnValue: null,
    item: null,
  });

  const handleShowFeriado = () => {
    const dato = {
      fecha: "",
      nombrefecha: "",
      idcalendarioferiado: "",
    };
    setDatoFeriado(dato);
    setIsnewFeriado(true);
    dispatchReducer({ type: "SHOW", typeModal: "ADMIN" });
  };

  const handleShowEditFeriado = (data) => {
    setDatoFeriado(data);
    setIsnewFeriado(false);
    dispatchReducer({ type: "SHOW", typeModal: "ADMIN" });
  };

  const handleShowChangePassword = (item) => {
    dispatchReducer({
      type: "SHOW",
      typeModal: "CHANGE_PASSWORD",
      item: { idadmin: item.idadmin, cuenta: item.cuenta },
    });
  };

  const onReturnDataAdmin = async (data, isnew, typeModal) => {
    dispatchReducer({ type: "END" });
    Swal.fire({
      title:
        typeModal === "CHANGE_PASSWORD"
          ? "Cambiando Contraseña"
          : typeModal === "ADMIN"
          ? "Guardando cuenta"
          : "Guardando",
      allowOutsideClick: false,
      showCancelButton: false,
      showConfirmButton: false,
      confirmButtonColor: "#00273a",
    });
    try {
      let result;
      if (typeModal === "CHANGE_PASSWORD") {
        result = await changePasswordAdmin({
          idadmin: data.idadmin,
          cuenta: data.cuenta,
          newPassword: data.newPassword,
        });
      } else if (typeModal === "ADMIN") {
        result = isnew ? await insertAdmin(data) : await updateAdmin(data);
      }

      if (result) {
        Swal.close();
        Swal.fire({
          title:
            typeModal === "CHANGE_PASSWORD"
              ? "Contraseña Cambiada"
              : typeModal === "ADMIN"
              ? "Cuenta guardada"
              : "Guardado",
          html:
            typeModal === "CHANGE_PASSWORD"
              ? "La contraseña se cambió correctamente"
              : typeModal === "ADMIN"
              ? isnew
                ? "La cuenta se creó correctamente"
                : "La cuenta se actualizó correctamente"
              : "Se modificó correctamente",
          icon: "success",
          confirmButtonColor: "#00273a",
        });
        if (typeModal !== "CHANGE_PASSWORD") {
          assigmentValueAdmin();
        }
      }
    } catch (err) {
      Swal.close();
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: `${err}`,
        confirmButtonColor: "#00273a",
      });
    }
  };

  const onCloseModal = () => {
    dispatchReducer({ type: "END" });
  };

  const EstadoAdmin = async (id) => {
    const result = await Swal.fire({
      title: "¿Está seguro?",
      text: "De cambiar el estado de la cuenta!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, cambiar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#00273a",
    });

    if (result.isConfirmed) {
      try {
        Swal.fire({
          title: "Actualizando",
          allowOutsideClick: false,
          showConfirmButton: false,
          showCancelButton: false,
          confirmButtonColor: "#00273a",
        });
        await UpdateEstadoAdmin(id);
        Swal.close();
        Swal.fire({
          title: "Cambiado",
          text: "Estado Actualizado.",
          icon: "success",
          confirmButtonColor: "#00273a",
        });
        await assigmentValueAdmin();
      } catch (err) {
        Swal.close();
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "No se pudo actualizar el estado.",
          confirmButtonColor: "#00273a",
        });
      }
    }
  };

  const renderContent = () => (
    <div className="row">
      {/* Admin Accounts Table */}
      <div className="col-xl-7 col-xxl-12 col-lg-12">
        <div className="card">
          <div className="card-header border-0 pb-0 d-flex justify-content-between">
            <h4 className="card-title">Cuentas Administrativos</h4>
            <Button variant="primary" size="sm" onClick={handleShowFeriado}>
              Agregar
            </Button>
          </div>
          <div className="card-body">
            <PerfectScrollbar
              style={{ height: "470px" }}
              options={{
                wheelPropagation: true,
                suppressScrollY: false,
                suppressScrollX: true,
              }}
              id="DZ_W_TimeLine"
              className="widget-timeline dlab-scroll height370 ps ps--active-y"
            >
              <div className="table-responsive">
                <Table striped bordered>
                  <thead>
                    <tr>
                      <th className="width80">
                        <strong>#</strong>
                      </th>
                      <th>
                        <strong>Cuenta</strong>
                      </th>
                      <th>
                        <strong>Nombre Completo</strong>
                      </th>
                      <th>
                        <strong>Estado</strong>
                      </th>
                      <th>
                        <strong>Opciones</strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {Feriados.map((item, index2) => {
                      const canModify =
                        userdata?.IdTipoUsuario === "0" ||
                        (userdata?.IdTipoUsuario === "1" &&
                          item.IdTipoUsuario === "2") ||
                        item.idadmin === userdata?.IdUsuario;

                      return (
                        <tr key={index2}>
                          <td>{item.idadmin}</td>
                          <td>{item.cuenta}</td>
                          <td>{item.nombrecompleto}</td>
                          <td
                            style={{
                              color:
                                item.estado === "INACTIVO" ? "red" : "green",
                            }}
                          >
                            {item.estado}
                          </td>
                          <td>
                            <div className="d-flex">
                              <li
                                className={`btn btn-primary shadow btn-xs sharp me-1 ${
                                  !canModify ? "disabled" : ""
                                }`}
                                onClick={() =>
                                  canModify && handleShowEditFeriado(item)
                                }
                                aria-disabled={!canModify}
                              >
                                <i className="fas fa-pencil-alt"></i>
                              </li>
                              <li
                                className={`btn btn-warning shadow btn-xs sharp me-1 ${
                                  !canModify ? "disabled" : ""
                                }`}
                                onClick={() =>
                                  canModify && handleShowChangePassword(item)
                                }
                                aria-disabled={!canModify}
                              >
                                <i className="fas fa-key"></i>
                              </li>
                              <li
                                className={`btn btn-danger shadow btn-xs sharp ${
                                  !canModify ? "disabled" : ""
                                }`}
                                onClick={() =>
                                  canModify && EstadoAdmin(item.idadmin)
                                }
                                aria-disabled={!canModify}
                              >
                                <i
                                  className={
                                    item.estado === "INACTIVO"
                                      ? "fas fa-undo"
                                      : "fa fa-trash"
                                  }
                                ></i>
                              </li>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            </PerfectScrollbar>
          </div>
        </div>
      </div>

      {/* Modals */}
      {reducer.isShow && reducer.typeModal === "ADMIN" && (
        <ModalCuentaAdmin
          estado={reducer.isShow}
          typeModal={reducer.typeModal}
          onCloseModal={onCloseModal}
          onReturnValue={onReturnDataAdmin}
          item={datoFeriado}
          isnew={isnewFeriado}
        />
      )}
      {reducer.isShow && reducer.typeModal === "CHANGE_PASSWORD" && (
        <ModalChangePassword
          estado={reducer.isShow}
          typeModal={reducer.typeModal}
          onCloseModal={onCloseModal}
          onReturnValue={onReturnDataAdmin}
          item={reducer.item}
        />
      )}
    </div>
  );

  return renderContent();
};

export default Admin;
